// extracted by mini-css-extract-plugin
export default {"pricing_page":"PricingPage_pricing_page__ADnXb","switch":"PricingPage_switch__a9qNO","active":"PricingPage_active__ZrP7t","cards":"PricingPage_cards__G3BhM"};